<form [formGroup]="form" (ngSubmit)="submit()" class="px-6 py-6 md:px-8 border-b">
    <div class="flex flex-col gap-4 max-w-lg">
        <mat-form-field>
            <mat-label>Umhverfi</mat-label>
            <input matInput [value]="selectedEnvironment | uppercase" readonly />
        </mat-form-field>
        <div class="flex gap-3 items-baseline">
            <mat-form-field class="flex-1">
                <mat-label>Upphafsdagur</mat-label>
                <input
                    matInput
                    [matDatepicker]="startPicker"
                    [min]="today"
                    formControlName="reservationStartDate"
                    (click)="startPicker.open()"
                    (dateChange)="onStartDateChange()"
                />
                <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
                <mat-datepicker #startPicker></mat-datepicker>
            </mat-form-field>
            <mat-form-field class="w-32">
                <mat-label>Tími</mat-label>
                <mat-select formControlName="reservationStartTime" (selectionChange)="onStartTimeChange()">
                    @for (t of startTimeOptions; track t) {
                        <mat-option [value]="t" [disabled]="isStartTimeDisabled(t)">{{ t }}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
            <div>
                <mat-checkbox formControlName="reservationStartNow" (change)="onReserveFromNowChange()">Taka frá strax</mat-checkbox>
            </div>
        </div>
        <div class="flex gap-3 items-start">
            <mat-form-field class="flex-1">
                <mat-label>Lokadagur</mat-label>
                <input
                    matInput
                    [matDatepicker]="endPicker"
                    [min]="minEndDate"
                    formControlName="reservationEndDate"
                    (click)="endPicker.open()"
                    (dateChange)="onEndDateChange()"
                />
                <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
                <mat-datepicker #endPicker></mat-datepicker>
            </mat-form-field>
            <mat-form-field class="w-32">
                <mat-label>Tími</mat-label>
                <mat-select formControlName="reservationEndTime">
                    @for (t of endTimeOptions; track t) {
                        <mat-option [value]="t" [disabled]="isEndTimeDisabled(t)">{{ t }}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>
        <mat-form-field subscriptSizing="dynamic">
            <mat-label>Númer á verkefnamiða í Azure DevOps</mat-label>
            <input matInput formControlName="reservationTicketId" inputmode="numeric" (keypress)="blockNonDigit($event)" />
            <mat-hint style="margin-bottom: 0 !important"
                >Greinar sem innihalda númerið t.d. feat/1234 munu ennþá ná að keyra inn breytingar ef það er source greinin á pull
                request-unni.</mat-hint
            >
        </mat-form-field>
        <mat-form-field>
            <mat-label>Ástæða</mat-label>
            <textarea matInput formControlName="reason" rows="3"></textarea>
        </mat-form-field>
        <div class="flex gap-3">
            <button mat-flat-button color="primary" type="submit">Vista</button>
            <button mat-button type="button" (click)="cancel.emit()">Hætta við</button>
        </div>
    </div>
</form>
